import React, { createContext, useContext, useReducer, useEffect, useRef } from 'react'
import { getUserData, USER_ACTIONS } from './userHelpers'

export const UserContext = createContext(null)

const reducer = (state, action) => {
  switch (action.type) {
    case USER_ACTIONS.LOADING:
      return { ...state, loading: true, user: null, error: null }
    case USER_ACTIONS.SUCCESS:
      return { ...state, loading: false, user: action.payload, error: null }
    case USER_ACTIONS.ERROR:
      return { ...state, loading: false, user: null, error: action.payload }
    default:
      throw new Error('Invalid action type')
  }
}

export const UserProvider = ({ children }) => {
  const tokenRef = useRef(null)
  const stateRef = useRef(null)

  const getAccessToken = () => tokenRef.current
  const updateAccessToken = (newToken) => {
    tokenRef.current = newToken
  }

  const [state, dispatch] = useReducer(reducer, {
    loading: false,
    user: null,
    error: null,
  })

  useEffect(() => {
    stateRef.current = state
  }, [state])

  useEffect(() => {
    const handleUserData = async (data) => {
      try {
        if (data?.detail?.auth?.profile) {
          updateAccessToken(data.detail.auth.access_token)

          if (!stateRef.current.user) {
            const userInfo = await getUserData(data.detail.auth, getAccessToken)
            dispatch({ type: USER_ACTIONS.SUCCESS, payload: userInfo })
          }
        }
      } catch (error) {
        dispatch({ type: USER_ACTIONS.ERROR, payload: error })
      }
    }

    dispatch({ type: USER_ACTIONS.LOADING })

    // eslint-disable-next-line no-undef
    window.addEventListener('auth-success', handleUserData)

    // eslint-disable-next-line no-undef
    window.dispatchEvent(
      new CustomEvent('auth-request-infos', {
        bubbles: true,
        composed: true,
      })
    )

    return () => {
      // eslint-disable-next-line no-undef
      window.removeEventListener('auth-success', handleUserData)
    }
  }, [])

  return <UserContext.Provider value={state}>{children}</UserContext.Provider>
}

export const useUser = () => useContext(UserContext)
